import { deleteObject, getDownloadURL, ref, uploadBytesResumable } from "firebase/storage"

import { storage } from "./firebase"

/**
 * A profilkép egyetlen helye a tárolóban: a feltöltés és a törlés ugyanazt a fájlt
 * címzi. A kiterjesztés fix, mert a kép a feltöltés előtt mindig átmegy a
 * kép-igazítón (`cropImageToSquare`), ami JPEG-et ad - a felhasználó által
 * választott formátum idáig már nem jut el.
 */
const profilePhotoRef = (uid: string) => ref(storage, `profilePictures/${uid}/profilePicture.jpg`)

/**
 * Profilkép feltöltése, a haladás jelentésével.
 *
 * A `cacheControl` azért lehet `immutable`, mert a felülírás új letöltési tokent
 * kap: a `getDownloadURL` más URL-t ad, tehát a böngésző gyorstárában maradt régi
 * fájl soha nem látszik újként.
 */
export async function uploadProfilePhoto(
  uid: string,
  file: File,
  onProgress?: (percent: number) => void
): Promise<string> {
  const storageRef = profilePhotoRef(uid)
  const task = uploadBytesResumable(storageRef, file, {
    contentType: file.type,
    cacheControl: "public, max-age=31536000, immutable",
  })

  if (onProgress) {
    task.on("state_changed", (snapshot) => {
      onProgress((snapshot.bytesTransferred / snapshot.totalBytes) * 100)
    })
  }

  await task
  return getDownloadURL(storageRef)
}

/**
 * A feltöltött profilkép törlése a tárolóból.
 *
 * A Google-fiókkal hozott profilképnek nincs fájlja a tárolóban, ilyenkor a
 * "nincs ilyen objektum" nem hiba: a hívó dolga (az Auth profilról levenni vagy
 * lecserélni a képet) akkor is elvégezhető.
 */
export async function deleteProfilePhoto(uid: string): Promise<void> {
  try {
    await deleteObject(profilePhotoRef(uid))
  } catch (error: unknown) {
    if (!(error instanceof Error && "code" in error && error.code === "storage/object-not-found")) {
      throw error
    }
  }
}
